import {Component, forwardRef, Input, TemplateRef} from "@angular/core";
import {AbstractControl, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";
import {FormControlBaseComponent} from "../form-control-base/form-control-base.component";

@Component({
    selector: "pcg-ng-search-text",
    template: require('./search-text.component.html'),
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SearchTextComponent), multi: true},
    ]
})
export class SearchTextComponent extends FormControlBaseComponent<string> {
    @Input()
    public template: TemplateRef<any>;

    public formControl: AbstractControl = new FormControl(this.DEFAULT_VALUE);

    public constructor() {
        super(/*DEFAULT_VALUE*/"");
    }

    public writeValue(value: any): void {
        super.writeValue(value);
        this.formControl.setValue(value, {emitEvent: false});
    }

    public submitSearchText(): void {
        this.writeNewValue(this.formControl.value);
    }
}
